import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';

// Direct Supabase Auth (GoTrue) recover — the Express /auth/forgot backend is
// undeployed. Same project + anon key as lib/sandbox.ts.
import { SUPABASE_URL, SUPABASE_KEY as SUPABASE_ANON } from '../../lib/supabaseConfig';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault();
    // Fire-and-forget; always show the same confirmation (no account enumeration).
    try {
      await fetch(`${SUPABASE_URL}/auth/v1/recover`, {
        method: 'POST',
        headers: { apikey: SUPABASE_ANON, 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
    } catch { /* swallow — confirmation is intentionally identical on failure */ }
    setDone(true);
  }
  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="card w-full max-w-md">
        <h1 className="text-2xl font-bold mb-2">Reset your password</h1>
        {done ? (
          <>
            <p className="text-sm text-slate-600">If that email is on file, a reset link has been sent.</p>
            {/* 🔴 THAT SENTENCE IS NOT ENOUGH ON ITS OWN (Ravi, 29 Sep 2026). Six people on live sign
                in with addresses on `rainmkr.local` — a domain that does not exist — so for them the
                link above is posted into the void and the screen cheerfully says it was sent. They
                would sit and wait for an email that can never arrive. We cannot name them here
                (saying "your address is fake" to whoever typed it is account enumeration), so the
                second sentence goes to everyone and costs nobody anything: it names the way out that
                does not depend on email at all, now that there IS one. */}
            <p className="text-sm text-slate-600 mt-2">
              If nothing arrives in the next few minutes, ask a director to set a new password for you —
              they can give you one to sign in with, and you choose your own from there.
            </p>
          </>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <Button type="submit" className="w-full">Send reset link</Button>
          </form>
        )}
        <div className="mt-4 text-sm">
          <Link to="/auth/login" className="text-slate-600 hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
